import Carousel from 'react-bootstrap/Carousel';
// import Timer from '../../components/Timer';
import slide1 from '../../images/slide_one.jpeg';
import slide2 from '../../images/slide2.jpeg';
import slide3 from '../../images/slide3.jpeg';

import SupportersLogo from '../../components2025/SupportersLogo.jsx';


// import SponsorsImg from '../components/SponsorsImg';
import { Link, useNavigate, useLocation } from "react-router-dom";

import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import Themes from '../../components2025/Themes.jsx';
import "../../stylesheets2025/registration.css";
import "../../stylesheets2025/home.css";
import brochureSanket from "../../pdf/brochure sanket.pdf"
import proposalSanket from "../../pdf/Sponsorship proposal sanket.pdf"
import Speakers from './Speakers.jsx';
import EventDetails from './EventDetails.jsx';
import Venue from './Venue.jsx';
import Awards from "./Awards.jsx"
import Supporters from './Supporters.jsx';
import CustomCarousel from '../../components2025/CustomCarousel.jsx';
import image1 from "../../images/conference/previous_conference_1.jpeg";
import image2 from "../../images/conference/previous_conference_2.jpeg";
import image3 from "../../images/conference/previous_conference_3.jpeg";
import image4 from "../../images/conference/previous_conference_4.jpeg";
import image5 from "../../images/conference/previous_conference_5.jpeg";
import image6 from "../../images/conference/previous_conference_6.jpeg";
import image7 from "../../images/conference/previous_conference_7.jpeg";


function getMonthName(monthNumber) {
  const date = new Date(2000, monthNumber - 1, 1); // Any year, month-1, day 1
  return new Intl.DateTimeFormat('en-US', { month: 'long' }).format(date);
}

const CONFERENCE_YEARS = ["2026", "2025", "2024"];

const Home = ({ day, month, year, startTime, endTime, weekDay, venue }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const routeYearMatch = location.pathname.match(/^\/(\d{4})(\/|$)/);
  const routeYear = routeYearMatch?.[1];
  const selectYear =
    routeYear && CONFERENCE_YEARS.includes(routeYear) ? routeYear : "2025";


  const monthName = getMonthName(month);
  const eventDate = new Date(`${year}-${month}-${day}T00:00:00Z`);

  const products = [
    { image: image1 },
    { image: image2 },
    { image: image3 },
    { image: image4 },
    { image: image5 },
    { image: image6 },
    { image: image7 },
  ];

  return (
    <>



      <div className="carouselplay">
        <Carousel>
          <Carousel.Item interval={4000}>
            <img src={slide1} alt="" />
          </Carousel.Item>
          <Carousel.Item interval={4000}>
            <img src={slide2} alt="" />
          </Carousel.Item>
          <Carousel.Item interval={4000}>
            <img src={slide3} alt="" />
          </Carousel.Item>
        </Carousel>

        {/*<div class="carousel slide"><div class="carousel-indicators"><button type="button" data-bs-target="" aria-label="Slide 1" aria-current="true" class="active"></button><button type="button" data-bs-target="" aria-label="Slide 2" aria-current="false"></button><button type="button" data-bs-target="" aria-label="Slide 3" aria-current="false"></button></div><div class="carousel-inner"><div interval="5000" class="active carousel-item"><img src="/pera-react-final/static/media/slide1.762c2c3e5c60cf51cff3.jpg" alt=""></div><div interval="5000" class="carousel-item"><img src="/pera-react-final/static/media/slide2.2faacea92ce0fa7b247c.jpg" alt=""></div><div interval="5000" class="carousel-item"><img src="/pera-react-final/static/media/slide3.9daa59e750abcd0a69f5.jpg" alt=""></div></div><a class="carousel-control-prev" role="button" tabindex="0" href="#" style="
    background: black;
    opacity: 1;
"><span aria-hidden="true" class="carousel-control-prev-icon"></span><span class="visually-hidden">Previous</span></a><a class="carousel-control-next" role="button" tabindex="0" href="#"><span aria-hidden="true" class="carousel-control-next-icon"></span><span class="visually-hidden">Next</span></a></div> */}
        <div className="cap ">

          <h1 className='text-lg lg:text-4xl'>
            SANKET  <br /> Sustainability through Ancient Knowledge and Emerging Technologies <br /> <span className='text-sm lg:text-xl'>{day}th {monthName}, {weekDay}, {startTime} - {endTime}, {venue} </span>
          </h1>
        </div>
      </div>


      <VerticalTimeline layout='1-column-right'>


        <VerticalTimelineElement
          className="vertical-timeline-element--work  "
          date={`Venue: ${venue}`}
          iconStyle={{ color: '#fff' }}


        >
          <h3 className="vertical-timeline-element-title">Event Date</h3>

          <p>
            {day}<sup>th</sup> {monthName}, {year}
          </p>

        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work  "

          iconStyle={{ color: '#fff' }}


        >
          <h3 className="vertical-timeline-element-title">Registration Begins</h3>

          <p>
            1<sup>st</sup> November, 2025
          </p>

        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--work  "

          iconStyle={{ color: '#fff' }}


        >
          <h3 className="vertical-timeline-element-title">Registration Closes</h3>

          <p>
            30<sup>th</sup> November, 2025
          </p>

        </VerticalTimelineElement>


      </VerticalTimeline>

      {/* PERA Sponsors */}


      <div style={{ textAlign: "center" }}>
        <h2>Previous conference images</h2>
        <CustomCarousel items={products} autoSlide={true} autoSlideInterval={3000} />
      </div>


      <div className="containAll flex flex-col justify-center items-center mb-5">
        {/* Page Heading */}
        <div className="heading">
          <h1>Registration</h1>
        </div>

        {/* Registration Forms Section */}
        <div className="form-container flex flex-col md:flex-row justify-center items-center gap-8 mt-10 mb-3">
          {/* Author Form */}
          <div className="form text-center">
            <p>Author’s Registration Form</p>
            <a
              href="https://forms.gle/ArPdVFGjiNu3jCRE8"
              target="_blank"
              rel="noopener noreferrer"
            >
              Author’s Registration Form
            </a>
          </div>

          {/* Attendee Form */}
          <div className="form text-center">
            <p>Attendees Registration Form (Without Paper)</p>
            <a
              href="https://forms.gle/esXbccnt3FieBUEw5"
              target="_blank"
              rel="noopener noreferrer"
            >
              Attendees Registration Form
            </a>
          </div>
        </div>

        {/* Know More Button */}
        <Link
          to="/2025/registration"
          className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
          style={{ textDecoration: "none" }}
          onClick={
            () => {

              if (window.outerWidth < 768) {
                document.querySelector('.navbar-toggler').click();
              }

              document.querySelectorAll('.nav-link').forEach((link) => {
                link.classList.remove('activeTab');
              })
              document.querySelectorAll('.nav-link')[6].classList.add('activeTab');
            }
          }
        >
          Know More Details on Registration
        </Link>
      </div>


      <div className="about-pera">
        <span className="heading lgreen">
          <h1>Core Themes</h1></span>

        {/* <ThemesList/> */}
        <Themes />


      </div>

      {/* spakers and pannel list */}
      {/* <div className='pt-5'>
        <Speakers />
      </div> */}
      {/* Event details page */}


      {/* <EventDetails /> */}



      {/* <Awards /> */}

      <Supporters />

      <div
        className="conference-select-wrap"
        style={{ textAlign: "center", marginBottom: "30px" }}
      >
        <label htmlFor="conference-year-select-2025" className="sr-only">
          Current and previous conferences — choose a year
        </label>
        <select
          id="conference-year-select-2025"
          className="conference-year-select"
          value={selectYear}
          aria-label="Switch conference year — 2026, 2025, or 2024"
          onChange={(e) => {
            const y = e.target.value;
            if (CONFERENCE_YEARS.includes(y)) {
              navigate(`/${y}`);
              setTimeout(() => window.scrollTo(0, 0), 0);
            }
          }}
        >
          <option value="2026">2026 — Current conference</option>
          <option value="2025">2025 — Previous conference</option>
          <option value="2024">2024 — Previous conference</option>
        </select>
      </div>


      <div className="brochure-section">
        <h2 className="brochure-title">Event Brochures</h2>

        <div className="brochure-container">
          <a
            href={brochureSanket}
            download="brochure-sanket.pdf"
            className="download-btn"
          >
            Download Brochure (PDF)
          </a>

          <a
            href={proposalSanket}
            download="Sponsorship-proposal-sanket.pdf"
            className="download-btn alt"
          >
            Download Sponsorship Proposal (PDF)
          </a>
        </div>
      </div>

      <Venue />



      {/* <div className="countdown">
        <Timer eventDate={eventDate} />
      </div> */}


    </>
  )
}

export default Home;